const target = 'customer'
export default {
  list: {
    config: {
      url: `/${target}/page`,
      method: 'post'
    }
  },
  query: {
    config: {
      url: `/${target}/id`,
      method: 'get'
    }
  },
  queryAll: {
    config: {
      url: `/${target}/query`,
      method: 'post'
    }
  }
}
